import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

console.log('[Index] Starting React application...');
const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('[Index] React root created, rendering App...');
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
console.log('[Index] App rendered successfully');

reportWebVitals(); 